import { ajax } from 'rxjs/ajax';
import { filter, fromEvent } from 'rxjs';
import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { OtherService } from 'src/app/services/other.service';
import { trigger, style, transition, animate } from '@angular/animations';
import { AccountService } from 'src/app/services/account.service';


@Component({

  selector: 'custom-gallery',

  templateUrl: './custom-gallery.component.html',

  styleUrls: ['./custom-gallery.component.css'],

  animations: [

    trigger('imageAnimation', [

      transition(':increment', [

        style({ transform: 'translateX(100%)', opacity: 0 }),

        animate('0.24s ease-out', style({ transform: 'translateX(0)', opacity: 1 })),

      ]),

      transition(':decrement', [

        style({ transform: 'translateX(-100%)', opacity: 0 }),

        animate('0.24s ease-out', style({ transform: 'translateX(0)', opacity: 1 })),

      ]),

    ]),

  ]

})

export class CustomGalleryComponent implements OnInit {

  @Input() albumIndex: number = 0; // ایندکس عکس در لیست تصاویر - ضروری

  @Input() lst_Album: any[] = []; // لیست تصاویر  - ضروری

  @Input() strKey_list: string = ''; // نام کلید تصویر در لیست - ضروری

  @Input() isDownloadAble: boolean = false; // آیا امکان دانلود تصویر وجود دارد - غیر ضروری

  constructor(private _other: OtherService, private _account: AccountService) { }

  ngOnInit(): void {

    if (this.lst_Album.length < 1) {

      throw new Error('lst_Album should not be empty')

    }

    if (this.strKey_list == '') {

      throw new Error('strKey_list is required')

    }

    const keydown$ = fromEvent<KeyboardEvent>(window, 'keydown');

    const rightArrowKey$ = keydown$.pipe(filter(event => event.key === 'ArrowRight'));

    const leftArrowKey$ = keydown$.pipe(filter(event => event.key === 'ArrowLeft'));

    rightArrowKey$.subscribe(() => {

      if (this.albumIndex != (this.lst_Album.length - 1)) {

        this.updateIndex(true);

      }

    })

    leftArrowKey$.subscribe(() => {

      if (this.albumIndex > 0) {

        this.updateIndex(false);

      }

    })

  }

  updateIndex(isNext: boolean) {

    if (isNext) {

      this.albumIndex = (this.albumIndex + 1) % this.lst_Album.length;

      this.download_Attachment(this.albumIndex)

    }

    else {

      this.albumIndex = (this.albumIndex - 1 + this.lst_Album.length) % this.lst_Album.length;

      this.download_Attachment(this.albumIndex)

    }

  }

  download_Attachment(index: number) {

    if (!this.isDownloadAble) return;

    if (this.lst_Album[this.albumIndex].isDownload) {

      return

    }

    else {

      var model = {

        iUserManager_User: this._other.getLocalStorage()?.Id ? this._other.getLocalStorage().Id : 0,

        strSession: this._other.getLocalStorage()?.session ? this._other.getLocalStorage()?.session : '',

        iMessage_Group: this.lst_Album[this.albumIndex].iMessage_Group

      }

      ajax.post(environment.baseUrl + `Message_Group_Info`, this._other.stringNumberToNumber(model), { 'Content-type': 'application/json' }).subscribe({

        next: (value: any) => {

          let response = JSON.parse(value.response);

          if (response.bError) return this._account.toastSwal('error', response.strError);

          this.lst_Album[index].strImageOrVoice = response[0].strImageOrVoice;

          this.lst_Album[index].isDownload = true;

        },

        error(err) {

          this.accountService.toastSwal('error', 'وضعیت اتصال خود را بررسی کنید');

          this.isDownloading = false;

        },

      });

    }

  }



}
